module.exports = __webpack_public_path__ + "img/50.08469526.08469526.svg";